import { inject, Injectable, signal } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
	providedIn: 'root'
})
export class ToastService {
	activeToasts = signal<number>(0);

	messageService = inject(MessageService);

	showSuccess(message: string, title: string = 'Success') {
		this.messageService.add({
			severity: 'success',
			summary: title,
			detail: message
		});
		this.updateToastCount(1);
	}

	showError(message: string, title: string = 'Error') {
		this.messageService.add({
			severity: 'error',
			summary: title,
			detail: message
		});
		this.updateToastCount(1);
	}

	showWarning(message: string, title: string = 'Warning') {
		this.messageService.add({
			severity: 'warn',
			summary: title,
			detail: message
		});
		this.updateToastCount(1);
	}

	showInfo(message: string, title: string = 'Info') {
		this.messageService.add({
			severity: 'info',
			summary: title,
			detail: message
		});
		this.updateToastCount(1);
	}

	private updateToastCount(delta: number) {
		this.activeToasts.update((count) => count + delta);

		// Auto-clear after some time
		setTimeout(() => {
			this.activeToasts.update((count) => Math.max(0, count - delta));
		}, 5000);
	}
}
